import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import useSWR from 'swr';
import { putApi } from '../../apiUtils';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import { UserColorsForm } from '../../forms/userColors/UserColorsForm';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { DetailPageParams } from '../../types/pageParams.types';
import { UserColor } from '../../types/userColor.types';
import { API_URL, fetcher } from '../../utils/apiUrl';

export function UserColorsEdit() {
  const { translate } = useTranslation();
  const transFormName = 'UserColor.Update';
  const history = useHistory();

  const { id } = useParams<DetailPageParams>();
  const { startLoading, stopLoading } = useLoading();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'Edit user color',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'User colors', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const { data: formData, error } = useSWR<UserColor>(
    `${API_URL.USER_COLOR_ITEM}?id=${id}`,
    fetcher,
  );

  const onSubmit = async (e) => {
    startLoading();
    if (e !== null) e.preventDefault();
    let isOk = false;
    await putApi({
      url: API_URL.USER_COLOR_UPDATE,
      data: formData,
      callAfterSuccess: () => {
        isOk = true;
      },
    });
    stopLoading();
    return isOk;
  };

  return (
    <PageContentWrapper
      error={error}
      loading={!formData}
      heading={translate!('Edit user color', transFormName)}
    >
      <UserColorsForm onSubmit={onSubmit} formData={formData} isEdit />
    </PageContentWrapper>
  );
}

export default UserColorsEdit;
